/** @format */

import { reducerDebug } from '../../core/debug';

export type IndicatedRangeReducersType = {
    type: string;
    selectedValue?: string | number;
    valueChange?: boolean;
};

export const indicatedRangeConstants = {
    SELECT_CHANGE: 'indicated_range_select',
};

export const indicatedRangeReducers = (state = {}, action: IndicatedRangeReducersType): object => {
    reducerDebug('indicated range reducer: ' + action.type);
    switch (action.type) {
        case indicatedRangeConstants.SELECT_CHANGE:
            return {
                ...state,
                ...action,
            };
        default:
            return { ...state };
    }
};
